import config from '../config'

class ContactForm {
    constructor(container) {
        this.container = container

        if (this.container) {
            this.form = this.container.querySelector('.contact-form')
            this.firstName = this.form.querySelector('[name="first_name"]')
            this.lastName = this.form.querySelector('[name="last_name"]')
            this.email = this.form.querySelector('[name="email"]')
            this.telephone = this.form.querySelector('[name="telephone"]')
            this.service = this.form.querySelector('[name="service"]')
            this.message = this.form.querySelector('[name="message"]')
            this.terms = this.form.querySelector('[name="terms"]')
            this.button = this.form.querySelector('.contact-form-submit')

            this.bindEventListeners()
        }
    }

    bindEventListeners() {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e))
    }

    handleSubmit(e) {
        e.preventDefault()

        const formData = new FormData()
        formData.append('action', 'reiss_edwards_submitContactForm')
        formData.append('security', config.security.submitContactForm)
        formData.append('first_name', this.firstName.value)
        formData.append('last_name', this.lastName.value)
        formData.append('email', this.email.value)
        formData.append('telephone', this.telephone.value)
        formData.append('service', this.service.value)
        formData.append('message', this.message.value)

        const xhr = new XMLHttpRequest()
        xhr.open('POST', config.ajaxUrl, true)

        this.setLoading(true)
        this.setError(false)

        xhr.onreadystatechange = () => {
            setTimeout(() => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        const response = JSON.parse(xhr.responseText)

                        if (response.status === 'success') {
                            window.location.replace(
                                `${config.siteUrl}/thank-you/`
                            )
                        } else {
                            this.setError(true)
                        }
                    }
                }

                this.setLoading(false)
            }, 1000)
        }

        xhr.onerror = () => {
            this.setLoading(false)
        }

        xhr.send(formData)
    }

    setError(error = false) {
        if (error) {
            this.container.classList.add('error')
        } else {
            this.container.classList.remove('error')
        }
    }

    setLoading(loading = false) {
        if (loading) {
            this.container.classList.add('loading')
        } else {
            this.container.classList.remove('loading')
        }
    }
}

export default ContactForm
